import React from 'react';
import AddEditLocation from "../../partial/AddEditLocation";
import Api from "util/Api";

const AddLocation = (props) => {
    const addLocation = async (data) => {
        const {org, timezone, type: isHomeCare} = data;
        return await Api.withAuth(props.auth).createFacility({org, timezone, isHomeCare});
    }

    return (
        <AddEditLocation
            {...props}
            sendRequest={addLocation}
            requestSuccessMessage='Location was successfully created'
            requestErrorMessage='Location already exist'
        />
    );
};

export default AddLocation;